<template>
  <div class="block-page">
    <BlockWrapper />
  </div>
</template>

<script>
import BlockWrapper from '@/wrappers/BlockWrapper.vue';

export default {
  name: 'BlockPage',
  components: {
    BlockWrapper,
  },
  data() {
    return {
        // Add your data properties here
    };
  },
  methods: {
      // Add your methods here
  },
  computed: {
      // Add your computed properties here
  },
  mounted() {
      // Lifecycle hook for when the component is mounted
  },
};
</script>

<style scoped>
.block-view {
    /* Add your styles here */
}
</style>